module.exports = __webpack_public_path__ + "media/Momentum_KnokDoorbell_InstallationVideo_Step9.1814ac3d.mp4";